import PropTypes from "prop-types"
import React, { Component } from "react"
import SignaturePad from "signature_pad/dist/signature_pad.js"
import { PICTURE_HEIGHT, PICTURE_WIDTH } from "./PicturesPage"

export class PictureCanvas extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func,
    drawingData: PropTypes.array,
    drawingEnabled: PropTypes.bool,
    pictureBase64: PropTypes.string,
    saveDrawingData: PropTypes.func,
    width: PropTypes.number,
    height: PropTypes.number,
  }

  static defaultProps = {
    drawingEnabled: true,
  }

  constructor() {
    super()

    this.canvas = React.createRef()
  }

  componentDidMount() {
    this.signaturePad = new SignaturePad(this.canvas.current, {
      backgroundColor: "rgba(255, 255, 255, 0)",
      penColor: "rgb(255, 233, 0)",
      minWidth: 1.1,
      maxWidth: 1.9,
      onEnd: this.doSaveDrawingData,
    })

    if (this.props.drawingData) {
      this.signaturePad.fromData(this.props.drawingData)
    }

    if (!canDraw(this.props)) {
      this.signaturePad.off()
    }
  }

  componentDidUpdate(previousProps, _previousState, _snapshot) {
    if (!this.props.drawingData) {
      this.signaturePad.clear()
    } else if (this.props.drawingData !== previousProps.initialDrawingData) {
      this.signaturePad.fromData(this.props.drawingData) // includes clearing before the new data is drawn
    }

    if (canDraw(this.props) && !canDraw(previousProps)) this.signaturePad.on()
    if (!canDraw(this.props) && canDraw(previousProps)) this.signaturePad.off()
  }

  discard = () => {
    this.signaturePad.clear()
    this.doSaveDrawingData()
  }

  doSaveDrawingData = () => {
    if (this.signaturePad.isEmpty()) {
      this.props.saveDrawingData(null)
    } else {
      const data = this.signaturePad.toData()
      this.props.saveDrawingData(data)
    }
  }

  render() {
    const { className, pictureBase64, onClick } = this.props
    const backgroundImage = pictureBase64 && `url(${pictureBase64})`

    const width = this.props.hasOwnProperty("width") ? this.props.width : PICTURE_WIDTH
    const height = this.props.hasOwnProperty("height") ? this.props.height : PICTURE_HEIGHT * (width / PICTURE_WIDTH)
    const sx = width / PICTURE_WIDTH
    const sy = height / PICTURE_HEIGHT
    const transform = sx !== 1 && sy !== 1 && `scale(${sx},${sy})`

    return (
      <div className={`picture-canvas ${className}`} style={{ width, height, backgroundImage }} onClick={onClick}>
        <canvas
          ref={this.canvas}
          className="drawing"
          width={PICTURE_WIDTH}
          height={PICTURE_HEIGHT}
          style={{ transform }}
        />
        {this.props.children}
      </div>
    )
  }
}

function canDraw(props) {
  return props.drawingEnabled && props.saveDrawingData
}

export default PictureCanvas



// WEBPACK FOOTER //
// ./src/features/damage-case/PictureCanvas.js